import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { structureDialogId, typeOfStructureDialog } from './StructureDialogConstants';

const baseSettings = {
  id: structureDialogId, // the same id for all zoom calls to reuse the same dialog
  movable: true,
  backdrop: false,
  resizable: true,
  closeOnBackdropClick: false,
  dialogType: typeOfStructureDialog,
};

export function open(id, structure, structureName) {
  return (dispatch) => {
    const openAction = updateDialog({
      ...baseSettings,
      structure,
      structureName,
    });

    dispatch(openAction);
  };
}

export function openWith3d(id, structure, projectName) {
  return (dispatch) => {
    const openAction = updateDialog({
      ...baseSettings,
      structure,
      show3dButton: true,
      projectName,
    });

    dispatch(openAction);
  };
}
